import Header from './Header';

export default Header;



// WEBPACK FOOTER //
// ./src/components/PagePage/components/Header/index.js